(function() {
  // ── UTILS ──────────────────────────────────────────────────────────────────
  var hoje = new Date(); hoje.setHours(0,0,0,0);
  var hojeISO = hoje.toISOString().slice(0,10);

  function fmtCurto(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    var m = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
    return p[2] + ' ' + m[parseInt(p[1])-1];
  }
  function fmtCompleto(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    return p[2]+'/'+p[1]+'/'+p[0];
  }
  function fmtBRL(c) { return (c/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'}); }
  function diffDias(i1, i2) {
    var a=new Date(i1+'T00:00:00'), b=new Date(i2+'T00:00:00');
    return Math.round((b-a)/86400000)+1;
  }
  // ── FRANQUIAS (1, 2 e 3 GB por dia) ────────────────────────────────────────
  // window.CF_TIERS traz uma entrada por franquia à venda (a desta página
  // sempre). Com duas ou mais, o cliente escolhe a franquia e o preço sai das
  // variantes dela; com menos, a página funciona como antes, com CF_VARIANTS.
  var TIERS = (window.CF_TIERS || []).filter(function(t) { return t.variants && t.variants.length; });
  var multi = TIERS.length > 1;
  var tierSel = null;
  // Sem pré-seleção na página de 1 GB (todo link do site cai nela); as páginas
  // de 2 GB e 3 GB abrem com a própria franquia escolhida.
  if (multi) {
    for (var ti = 0; ti < TIERS.length; ti++) if (TIERS[ti].atual && TIERS[ti].gb > 1) tierSel = TIERS[ti];
  }
  function tierPorGb(gb) {
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i].gb === gb) return TIERS[i];
    return null;
  }
  function variantesAtuais() {
    if (!multi) return window.CF_VARIANTS || [];
    return tierSel ? tierSel.variants : [];
  }
  function gbAtual() {
    if (tierSel) return tierSel.gb;
    return TIERS.length ? TIERS[0].gb : 1;
  }
  function buscarVariante(n, vars) {
    vars = vars || variantesAtuais();
    for(var i=0;i<vars.length;i++) if(vars[i].days===n) return vars[i];
    for(var j=0;j<vars.length;j++) if(vars[j].days>=n) return vars[j];
    return vars.length ? vars[vars.length-1] : null;
  }
  // ── 3 GB SÓ EM ALGUNS DESTINOS ─────────────────────────────────────────────
  // Cópia de GRUPOS_3GB de franquias-chip.js (raiz do repositório): mudou lá,
  // mude aqui — o teste confere. 1 e 2 GB valem para todo destino; 3 GB só
  // quando todos os países da viagem cabem num mesmo grupo (o chip leva um
  // plano só: Alemanha + China vira plano global, que para em 2 GB).
  var GRUPOS_3GB = [
    ["Albânia", "Alemanha", "Áustria", "Bélgica", "Bósnia e Herzegovina", "Bulgária", "Chipre", "Croácia", "Dinamarca", "Eslováquia", "Eslovênia", "Espanha", "Estônia", "Finlândia", "França", "Gibraltar", "Grécia", "Guadalupe", "Guiana Francesa", "Holanda", "Hungria", "Ilhas Faroé", "Irlanda", "Islândia", "Itália", "Letônia", "Liechtenstein", "Lituânia", "Luxemburgo", "Malta", "Martinica", "Montenegro", "Noruega", "Polônia", "Portugal", "Reino Unido", "Rep. Tcheca", "Romênia", "Rússia", "Sérvia", "Suécia", "Suíça", "Turquia", "Ucrânia"],
    ["África do Sul", "Ilhas Maurício", "Moçambique", "Rep. Democrática do Congo", "Tanzânia"],
    ["Austrália", "Nova Zelândia"],
    ["China", "Hong Kong", "Macau", "Taiwan"],
    ["China", "Vietnã"],
    ["Singapura", "Malásia", "Tailândia"],
    ["Japão"]
  ];
  // O seletor escreve "Ilhas Mauricio": compara sem acento.
  function semAcento(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }
  var GRUPOS_3GB_N = GRUPOS_3GB.map(function(g) { return g.map(semAcento); });
  function paisesViagem() { return window.CF_SELECTED_COUNTRIES || []; }
  function tem3gb(paises) {
    if (!paises.length) return true;
    return GRUPOS_3GB_N.some(function(g) {
      return paises.every(function(p) { return g.indexOf(semAcento(p)) >= 0; });
    });
  }
  function listaTexto(xs) { return xs.length > 1 ? xs.slice(0, -1).join(', ') + ' e ' + xs[xs.length - 1] : xs.join(''); }
  // '' quando 3 GB vale para a viagem (ou nenhum país foi escolhido).
  function aviso3gb(paises) {
    if (tem3gb(paises)) return '';
    var fora = paises.filter(function(p) {
      var k = semAcento(p);
      return !GRUPOS_3GB_N.some(function(g) { return g.indexOf(k) >= 0; });
    });
    return '3 GB por dia não está disponível para ' + (fora.length ? listaTexto(fora) : listaTexto(paises) + ' na mesma viagem') + '. Escolha 1 ou 2 GB por dia.';
  }

  // Marca a franquia escolhida e mostra o total de cada uma para n dias
  // (n = 0: sem datas ou acima de 90 dias, botões sem preço). Com países fora
  // dos grupos de 3 GB, o botão de 3 GB fica desligado, perde a seleção (a
  // página de 3 GB abre com ela) e a nota diz por quê.
  function renderTiers(n) {
    var box = document.getElementById('cf-tiers');
    if (!box) return;
    var paises = paisesViagem();
    var ok3 = tem3gb(paises);
    if (!ok3 && tierSel && tierSel.gb === 3) tierSel = null;
    var btns = box.querySelectorAll('.cf-tier');
    for (var i = 0; i < btns.length; i++) {
      var gb = parseInt(btns[i].getAttribute('data-gb'), 10);
      var t = tierPorGb(gb);
      var off = gb === 3 && !ok3;
      var on = !!(tierSel && tierSel.gb === gb);
      btns[i].disabled = off;
      btns[i].classList.toggle('off', off);
      btns[i].classList.toggle('on', on);
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
      var pr = btns[i].querySelector('.cf-tier-preco');
      var v = (t && n && !off) ? buscarVariante(n, t.variants) : null;
      if (pr) pr.textContent = off ? 'indisponível' : (v ? fmtBRL(v.price) : '');
    }
    var nota = document.getElementById('cf-tier-nota');
    if (nota) {
      var txt = aviso3gb(paises);
      nota.textContent = txt;
      nota.style.display = txt ? 'block' : 'none';
    }
  }

  // ── CALENDÁRIO INLINE ──────────────────────────────────────────────────────
  var MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
  var cfCal  = { y:0, m:0, start:null, end:null, mode:'start', hover:null };
  var calEventsReady = false;

  function cfCalInit() {
    // Ambos vão para body como irmãos — calendário position:fixed;bottom:0
    // e backdrop position:fixed;inset:0 por trás
    var cal = document.getElementById('cf-inline-cal');
    var bd  = document.getElementById('cf-cal-backdrop');
    if (bd && bd.parentNode !== document.body) {
      document.body.appendChild(bd);
      bd.addEventListener('touchmove', function(e) { e.preventDefault(); }, { passive: false });
    }
    if (cal && cal.parentNode !== document.body) {
      document.body.appendChild(cal);
    }

    var t = new Date();
    cfCal.y = t.getFullYear(); cfCal.m = t.getMonth();
    cfCal.start = null; cfCal.end = null;
    cfCal.mode = 'start'; cfCal.hover = null;
    cfCalRender();
    if (!calEventsReady) { cfCalSetupEvents(); calEventsReady = true; }
    cfCalHint();
    cfCalSyncCardStates();
  }

  function cfCalRenderMonth(g, y, m, showPrev, showNext) {
    if (!g) return;
    var _t = [0,3,2,5,0,3,5,1,4,6,2,4];
    var _y = m < 2 ? y - 1 : y;
    var firstDow = (_y + Math.floor(_y/4) - Math.floor(_y/100) + Math.floor(_y/400) + _t[m] + 1) % 7;
    var _dim = [31,28,31,30,31,30,31,31,30,31,30,31];
    var daysInMonth = _dim[m] + (m === 1 && (y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0)) ? 1 : 0);
    var canPrev = showPrev && !(y === hoje.getFullYear() && m === hoje.getMonth());

    var html = '<div class="cf-month-nav">'
      + '<button class="cf-nav-btn'+(canPrev?'':' invisible')+'" onclick="cfCalPrev()">&#8249;</button>'
      + '<span class="cf-month-name">'+MESES[m]+' '+y+'</span>'
      + '<button class="cf-nav-btn'+(showNext?'':' invisible')+'" onclick="cfCalNext()">&#8250;</button>'
      + '</div>'
      + '<div class="cf-cal-grid">';

    var dows = ['D','S','T','Q','Q','S','S'];
    for (var i = 0; i < 7; i++) html += '<div class="cf-dow">'+dows[i]+'</div>';
    for (var e = 0; e < firstDow; e++) html += '<div class="cf-day cf-cal-blank"></div>';

    for (var d = 1; d <= daysInMonth; d++) {
      var iso = y + '-' + (m < 9 ? '0' : '') + (m+1) + '-' + (d < 10 ? '0' : '') + d;
      var isPast    = iso < hojeISO;
      var isToday   = iso === hojeISO;
      var isStart   = iso === cfCal.start;
      var isEnd     = iso === cfCal.end;
      var isDisabled = isPast;
      var inRange   = !!(cfCal.start && cfCal.end && iso > cfCal.start && iso < cfCal.end);

      var cls = 'cf-day';
      if (isDisabled) cls += ' past';
      else if (isToday && !isStart && !isEnd) cls += ' today';
      if (isStart)           cls += ' start';
      if (isEnd && !isStart) cls += ' end';
      if (inRange)           cls += ' inrange';

      html += '<div class="'+cls+'" data-iso="'+iso+'" data-base-past="'+(isPast?'1':'0')+'">'+d+'</div>';
    }
    html += '</div>';
    g.innerHTML = html;
  }

  function cfCalIsDesktop() {
    var g2 = document.getElementById('cf-calpop-grid2');
    return !!(g2 && window.innerWidth >= 768);
  }

  function cfCalRender() {
    var g1 = document.getElementById('cf-calpop-grid');
    var g2 = document.getElementById('cf-calpop-grid2');
    if (!g1) return;

    var desktop = cfCalIsDesktop();
    cfCalRenderMonth(g1, cfCal.y, cfCal.m, true, !desktop);

    if (desktop) {
      var ny = cfCal.m === 11 ? cfCal.y + 1 : cfCal.y;
      var nm = cfCal.m === 11 ? 0 : cfCal.m + 1;
      cfCalRenderMonth(g2, ny, nm, false, true);
      if (g2) g2.style.display = '';
    } else {
      if (g2) g2.style.display = 'none';
    }

    if (cfCal.mode === 'end' && cfCal.start) cfCalApplyRangeClasses();
  }

  // Event delegation — set once, survives innerHTML rebuilds
  function cfCalSetupEvents() {
    ['cf-calpop-grid','cf-calpop-grid2'].forEach(function(id) {
      var g = document.getElementById(id);
      if (!g) return;
      g.addEventListener('mouseover', function(e) {
        var day = e.target.closest('[data-iso]');
        if (!day || day.classList.contains('past')) return;
        if (cfCal.mode !== 'end' || !cfCal.start) return;
        var iso = day.dataset.iso;
        if (iso !== cfCal.hover) { cfCal.hover = iso; cfCalApplyRangeClasses(); }
      });
      g.addEventListener('mouseleave', function() {
        if (cfCal.mode === 'end' && cfCal.hover) { cfCal.hover = null; cfCalApplyRangeClasses(); }
      });
      g.addEventListener('click', function(e) {
        var day = e.target.closest('[data-iso]');
        if (!day || day.dataset.basePast === '1') return;
        cfCalClickDay(day.dataset.iso);
      });
    });
  }

  // Atualiza classes sem rebuild HTML — usado no hover
  function cfCalApplyRangeClasses() {
    var effEnd = (cfCal.mode === 'end' && cfCal.hover) ? cfCal.hover : (cfCal.end || cfCal.hover);
    ['cf-calpop-grid','cf-calpop-grid2'].forEach(function(id) {
      var g = document.getElementById(id);
      if (!g) return;
      g.querySelectorAll('[data-iso]').forEach(function(el) {
        var iso      = el.dataset.iso;
        var basePast = el.dataset.basePast === '1';
        var disabled = basePast;
        el.classList.toggle('past', disabled);
        if (disabled) { el.classList.remove('inrange','end'); return; }
        var isStart      = iso === cfCal.start;
        var isConfirmEnd = (cfCal.mode !== 'end' || !cfCal.hover) && iso === cfCal.end;
        var isHoverEnd   = cfCal.mode === 'end' && iso === cfCal.hover;
        var inRange      = !!(cfCal.start && effEnd && iso > cfCal.start && iso < effEnd);
        el.classList.toggle('start',   isStart);
        el.classList.toggle('end',     (isConfirmEnd || isHoverEnd) && !isStart);
        el.classList.toggle('inrange', inRange && !isStart && !isConfirmEnd && !isHoverEnd);
      });
    });
  }

  // Seleção rápida por duração
  window.cfCalQuick = function(n) {
    if (!cfCal.start) return;
    var d = new Date(cfCal.start + 'T00:00:00');
    d.setDate(d.getDate() + n - 1);
    var endISO = d.getFullYear() + '-'
      + (d.getMonth() < 9 ? '0' : '') + (d.getMonth()+1) + '-'
      + (d.getDate() < 10 ? '0' : '') + d.getDate();
    cfCal.y = parseInt(cfCal.start.split('-')[0]);
    cfCal.m = parseInt(cfCal.start.split('-')[1]) - 1;
    cfCal.end = endISO; cfCal.mode = 'done'; cfCal.hover = null;
    cfCalRender(); cfCalHint(); cfCalSyncCardStates();
    atualizarUI(cfCal.start, cfCal.end);
  };

  function cfCalClickDay(iso) {
    if (cfCal.mode === 'start' || cfCal.mode === 'done') {
      cfCal.start = iso; cfCal.end = null;
      cfCal.mode = 'end'; cfCal.hover = null;
    } else {
      if (iso > cfCal.start) {
        cfCal.end = iso; cfCal.mode = 'done'; cfCal.hover = null;
      } else {
        // Clicou antes/igual ao início — recomeça
        cfCal.start = iso; cfCal.end = null;
        cfCal.mode = 'end'; cfCal.hover = null;
      }
    }
    cfCalRender();
    cfCalHint();
    cfCalSyncCardStates();
    atualizarUI(cfCal.start || '', cfCal.end || '');
    cfCalUpdateFooter();
  }

  function cfCalHint() {}

  function cfCalUpdateFooter() {
    var summary = document.getElementById('cf-modal-summary');
    var applyBtn = document.getElementById('cf-modal-apply');
    if (!summary) return;
    var m = ['jan','fev','mar','abr','mai','jun','jul','ago','set','out','nov','dez'];
    function fmt(iso) { var p=iso.split('-'); return p[2]+' '+m[parseInt(p[1])-1]; }
    if (cfCal.start && cfCal.end) {
      var n = diffDias(cfCal.start, cfCal.end);
      summary.textContent = 'Plano de ' + n + (n>1?' dias':' dia') + '  |  ' + fmt(cfCal.start) + ' – ' + fmt(cfCal.end) + '.';
      if (applyBtn) applyBtn.disabled = false;
    } else if (cfCal.start) {
      summary.textContent = 'Selecione a data de partida';
      if (applyBtn) applyBtn.disabled = true;
    } else {
      summary.textContent = 'Selecione a data de chegada';
      if (applyBtn) applyBtn.disabled = true;
    }
  }

  window.cfCalApply = function() {
    if (cfCal.start && cfCal.end) cfCalClose();
  };

  function cfCalSyncCardStates() {
    var c1 = document.getElementById('cf-card-d1');
    var c2 = document.getElementById('cf-card-d2');
    if (c1) c1.classList.toggle('cf-date-card-active', cfCal.mode === 'start');
    if (c2) c2.classList.toggle('cf-date-card-active', cfCal.mode === 'end');
  }

  window.cfCalPrev = function() {
    if (cfCal.m === 0) { cfCal.m = 11; cfCal.y--; } else cfCal.m--;
    cfCalRender();
  };
  window.cfCalNext = function() {
    if (cfCal.m === 11) { cfCal.m = 0; cfCal.y++; } else cfCal.m++;
    cfCalRender();
  };
  window.cfCalClear = function() {
    cfCal.start = null; cfCal.end = null;
    cfCal.mode  = 'start'; cfCal.hover = null;
    cfCalRender(); cfCalHint(); cfCalSyncCardStates();
    atualizarUI('', '');
    cfCalOpen();
  };
  var _scrollY = 0;

  function cfCalLockScroll() {
    _scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.style.width = '100%';
  }

  function cfCalUnlockScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _scrollY);
  }

  function cfCalOpen() {
    var cal = document.getElementById('cf-inline-cal');
    if (!cal) return;
    if (!cfCalIsDesktop()) {
      cfCalLockScroll();
    } else {
      cal.style.height = '';
    }
    cal.classList.add('open');
    var bd = document.getElementById('cf-cal-backdrop');
    if (bd) bd.classList.add('open');
    cfCalRender();
    cfCalUpdateFooter();
  }
  window.cfCalClose = function() {
    var cal = document.getElementById('cf-inline-cal');
    if (cal) cal.classList.remove('open');
    var bd = document.getElementById('cf-cal-backdrop');
    if (bd) bd.classList.remove('open');
    if (!cfCalIsDesktop()) cfCalUnlockScroll();
  };
  var cfCalClose = window.cfCalClose;

  window.cfCalPickStart = function() {
    cfCal.mode  = 'start';
    cfCal.hover = null;
    if (cfCal.start) {
      var p = cfCal.start.split('-');
      cfCal.y = parseInt(p[0]); cfCal.m = parseInt(p[1]) - 1;
    }
    cfCalRender(); cfCalHint(); cfCalSyncCardStates();
    cfCalOpen();
  };
  window.cfCalPickEnd = function() {
    if (!cfCal.start) { cfCalOpen(); return; }
    cfCal.mode = 'end'; cfCal.hover = null;
    var ref = cfCal.end || cfCal.start;
    var p = ref.split('-');
    cfCal.y = parseInt(p[0]); cfCal.m = parseInt(p[1]) - 1;
    cfCalRender(); cfCalHint(); cfCalSyncCardStates();
    cfCalOpen();
  };

  // ── UI (preço, botão, cards) ────────────────────────────────────────────────
  function atualizarCards(iso1, iso2) {
    var el1  = document.getElementById('cf-d1');
    var el2  = document.getElementById('cf-d2');
    var card1 = document.getElementById('cf-card-d1');
    var card2 = document.getElementById('cf-card-d2');

    if (el1) {
      if (iso1) {
        el1.textContent = fmtCurto(iso1); el1.classList.remove('placeholder');
        if (card1) {
          card1.classList.add('filled');
          card1.style.transform = 'scale(1.03)';
          setTimeout(function(){ card1.style.transform = ''; }, 180);
        }
      } else {
        el1.textContent = 'Selecione'; el1.classList.add('placeholder');
        if (card1) card1.classList.remove('filled');
      }
    }
    if (el2) {
      if (iso2) {
        el2.textContent = fmtCurto(iso2); el2.classList.remove('placeholder');
        if (card2) {
          card2.classList.add('filled');
          card2.style.transform = 'scale(1.03)';
          setTimeout(function(){ card2.style.transform = ''; }, 180);
        }
      } else {
        el2.textContent = 'Selecione'; el2.classList.add('placeholder');
        if (card2) card2.classList.remove('filled');
      }
    }
  }

  function atualizarUI(iso1, iso2) {
    atualizarCards(iso1, iso2);

    var elP  = document.getElementById('cf-price');
    var elS  = document.getElementById('cf-sub');
    var pill = document.getElementById('cf-pill');
    var pillT= document.getElementById('cf-pill-txt');
    var btn  = document.getElementById('cf-btn');
    var vid  = document.getElementById('cf-vid');

    if (iso1 && iso2) {
      var n = diffDias(iso1, iso2);
      if (pill)  pill.style.display = 'flex';
      if (pillT) pillT.textContent  = n + (n !== 1 ? ' dias' : ' dia') + ' de viagem';

      var msg30 = document.getElementById('cf-msg-30');
      if (n > 90) {
        renderTiers(0);
        if (msg30) msg30.style.display = 'block';
        if (elP)   elP.textContent = n + ' dias de viagem';
        if (elS)   elS.textContent = 'Planos acima de 90 dias sob consulta';
        if (vid)   vid.value = '';
        if (btn) {
          btn.disabled    = false;
          btn.textContent = 'Falar com nossa equipe →';
          btn.onclick = function() {
            var msg = 'Ol%C3%A1%2C%20preciso%20de%20um%20chip%20para%20' + n + '%20dias%20de%20viagem.';
            window.open('https://api.whatsapp.com/send?phone=551132311000&text=' + msg, '_blank');
          };
        }
      } else {
        renderTiers(n);
        if (msg30) msg30.style.display = 'none';
        var v   = buscarVariante(n);
        var hasCountry = window.CF_SELECTED_COUNTRIES && window.CF_SELECTED_COUNTRIES.length > 0;
        if (!v) {
          // Várias franquias à venda e nenhuma escolhida: o preço espera a escolha.
          if (elP) elP.innerHTML = '<span style="font-size:20px;font-weight:400;color:rgba(255,255,255,.5)">Escolha a franquia</span>';
          if (elS) elS.textContent = n + (n !== 1 ? ' dias' : ' dia') + ' de viagem · escolha a internet por dia';
          if (vid) vid.value = '';
          if (btn) {
            btn.disabled = true; btn.onclick = null;
            btn.textContent = hasCountry ? 'Escolha a franquia diária' : 'Selecione ao menos 1 país de destino';
          }
        } else {
          var tot = fmtBRL(v.price);
          var ppd = fmtBRL(Math.round(v.price / n));
          if (elP) elP.textContent = tot;
          if (elS) elS.textContent = n + (n !== 1 ? ' dias' : ' dia') + ' · ' + ppd + '/dia · ' + gbAtual() + ' GB/dia';
          if (vid) vid.value = v.id;
          if (btn) {
            if (!hasCountry) {
              btn.disabled = true; btn.onclick = null;
              btn.textContent = 'Selecione ao menos 1 país de destino';
            } else {
              btn.onclick = window.cfBuy; btn.disabled = false;
              btn.textContent = 'Comprar chip — ' + tot;
            }
          }
        }
      }
    } else {
      renderTiers(0);
      if (elP)  elP.innerHTML = '<span style="font-size:20px;font-weight:400;color:rgba(255,255,255,.5)">Selecione as datas</span>';
      if (elS)  elS.textContent = (elS.dataset.padrao || 'A partir de ' + (elS.dataset.precoMin || '') + ' · 1 GB/dia');
      if (pill) pill.style.display = 'none';
      if (vid)  vid.value = '';
      if (btn)  { btn.disabled = true; btn.textContent = 'Selecione as datas da viagem'; }
    }
  }

  // ── COMPRA ─────────────────────────────────────────────────────────────────
  // As propriedades da linha do chip, num lugar só: a compra (cfBuy) e a
  // revenda (cfSelecao) leem daqui. "Paises de destino" só com país escolhido.
  function propriedadesChip(iso1, iso2) {
    var props = { 'Data de chegada': fmtCompleto(iso1), 'Data de retorno': fmtCompleto(iso2) };
    var paises = window.CF_SELECTED_COUNTRIES || [];
    if (paises.length) props['Paises de destino'] = paises.join(', ');
    return props;
  }

  window.cfBuy = function() {
    var iso1 = cfCal.start, iso2 = cfCal.end;
    var vid  = document.getElementById('cf-vid');
    if (!iso1 || !iso2 || !vid || !vid.value) return;
    if (gbAtual() === 3 && !tem3gb(paisesViagem())) { window.cfRefreshBtn(); return; }
    if (temChina() && !chinaLida) { window.cfChinaOpen(true); return; }
    var btn = document.getElementById('cf-btn');
    var n   = diffDias(iso1, iso2);
    var v   = buscarVariante(n);
    btn.disabled = true; btn.textContent = 'Adicionando...';
    var cfProps = propriedadesChip(iso1, iso2);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({id: parseInt(vid.value), quantity: 1, properties: cfProps})
    })
    .then(function(r) { return r.ok ? r.json() : r.json().then(function(e){ throw e; }); })
    .then(function() {
      fetch('/cart?section_id=cart-drawer').then(function(r){ return r.text(); }).then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nd  = doc.getElementById('CartDrawer');
        var cd  = document.getElementById('CartDrawer');
        if (nd && cd) cd.innerHTML = nd.innerHTML;
        if (cd) cd.parentElement.classList.remove('is-empty');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        setTimeout(function() {
          var dr = document.getElementById('CartDrawer');
          if (dr) {
            dr.parentElement.classList.add('active');
            var ov = document.getElementById('CartDrawer-Overlay');
            if (ov) ov.classList.add('active');
            document.body.classList.add('overflow-hidden');
          } else {
            var ci = document.getElementById('cart-icon-bubble');
            if (ci) ci.click();
          }
        }, 100);
      });
    })
    .catch(function(err) { alert(err.description || 'Erro ao adicionar ao carrinho'); })
    .finally(function() {
      btn.disabled = false;
      if (v) btn.textContent = 'Comprar chip — ' + fmtBRL(v.price);
    });
  };

  // Para a revenda: a variante e as propriedades que cfBuy poria no carrinho, ou
  // null. Mesmas travas da compra, mais ao menos um país (a regra do botão).
  // Nunca compra: o aviso da China abre fora do modo de compra, porque o aviso
  // aberto pela compra compra ao ser confirmado.
  window.cfSelecao = function(opcoes) {
    var avisar = !!(opcoes && opcoes.avisar);
    var iso1 = cfCal.start, iso2 = cfCal.end;
    var vid  = document.getElementById('cf-vid');
    if (!iso1 || !iso2 || !vid || !vid.value) return null;
    if (!paisesViagem().length) return null;
    if (gbAtual() === 3 && !tem3gb(paisesViagem())) { if (avisar) window.cfRefreshBtn(); return null; }
    if (temChina() && !chinaLida) { if (avisar) window.cfChinaOpen(false); return null; }
    return { variantId: String(vid.value), propriedades: propriedadesChip(iso1, iso2) };
  };

  window.cfRefreshBtn = function() { atualizarUI(cfCal.start || '', cfCal.end || ''); };

  // Clique num botão de franquia: troca preço, variante e botão na hora.
  window.cfTier = function(gb) {
    var t = tierPorGb(parseInt(gb, 10));
    if (!t || (t.gb === 3 && !tem3gb(paisesViagem()))) return;
    tierSel = t;
    atualizarUI(cfCal.start || '', cfCal.end || '');
  };

  // ── CHINA: ativar fora da China, desembarcar em até 48 h (desde julho de 2026)
  // Só a China continental: Hong Kong, Macau e Taiwan têm regra própria.
  function temChina() {
    var sel = window.CF_SELECTED_COUNTRIES || [];
    for (var i = 0; i < sel.length; i++) if (sel[i] === 'China') return true;
    return false;
  }
  var chinaLida = false;      // o cliente já clicou "Entendi, continuar" nesta visita
  var chinaComprando = false; // o popup foi aberto pelo botão de compra (ao confirmar, compra)

  window.cfChinaRefresh = function() {
    var msg = document.getElementById('cf-msg-china');
    if (msg) msg.style.display = temChina() ? 'block' : 'none';
    if (!temChina()) chinaLida = false;
  };

  // Data concreta dentro do popup, quando a chegada já foi escolhida:
  // "Para a chegada em dd/mm/aaaa, ative no dia do embarque".
  function janelaChina() {
    var el = document.getElementById('cf-china-janela');
    if (!el) return;
    if (!cfCal.start) { el.textContent = ''; return; }
    el.innerHTML = ' Para a chegada em <strong>' + fmtCompleto(cfCal.start) + '</strong>, ative no dia do embarque.';
  }

  window.cfChinaOpen = function(comprando) {
    chinaComprando = !!comprando;
    janelaChina();
    var m = document.getElementById('cf-china-modal'), b = document.getElementById('cf-china-backdrop');
    // .cf-pcard tem transform (animação de entrada), o que prende o position:fixed
    // e abria o popup deslocado. No body ele centraliza na janela de verdade.
    if (m && m.parentElement !== document.body) { document.body.appendChild(b); document.body.appendChild(m); }
    if (m) m.classList.add('open');
    if (b) b.classList.add('open');
    var ok = document.getElementById('cf-china-ok');
    if (ok) ok.textContent = chinaComprando ? 'Entendi, continuar a compra' : 'Entendi';
  };
  window.cfChinaClose = function() {
    var m = document.getElementById('cf-china-modal'), b = document.getElementById('cf-china-backdrop');
    if (m) m.classList.remove('open');
    if (b) b.classList.remove('open');
    chinaComprando = false;
  };
  window.cfChinaOk = function() {
    chinaLida = true;
    var comprar = chinaComprando;
    window.cfChinaClose();
    if (comprar) window.cfBuy();
  };

  // ── FAQ ────────────────────────────────────────────────────────────────────
  window.cfFaq = function(btn) {
    var item = btn.closest('.cf-faq-item');
    var was  = item.classList.contains('open');
    var all  = document.querySelectorAll('.cf-faq-item');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('open');
    if (!was) item.classList.add('open');
  };

  // ── INIT ───────────────────────────────────────────────────────────────────
  var obs = new IntersectionObserver(function(e) {
    e.forEach(function(x) { if (x.isIntersecting) { x.target.classList.add('vis'); obs.unobserve(x.target); } });
  }, {threshold: 0.08});

  function init() {
    cfCalInit();
    atualizarUI('', '');
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') cfCalClose();
    });
    document.addEventListener('click', function(e) {
      var cal    = document.getElementById('cf-inline-cal');
      var anchor = document.getElementById('cf-cal-anchor');
      if (!cal || !cal.classList.contains('open')) return;
      if (cal.contains(e.target)) return;
      if (anchor && anchor.contains(e.target)) return;
      cfCalClose();
    }, true);
    var fus = document.querySelectorAll('.fu');
    for (var i = 0; i < fus.length; i++) {
      fus[i].style.transitionDelay = Math.min(i % 5 * 50, 200) + 'ms';
      obs.observe(fus[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
